import { render, staticRenderFns } from "./DrivingBehaviour.vue?vue&type=template&id=96b57268&"
import script from "./DrivingBehaviour.vue?vue&type=script&lang=js&"
export * from "./DrivingBehaviour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports